<template>
    <div class="authenticated-area-menu-controller">
        <div class="display-content-wrapper">
			<!-- Home for mobile -->
			<home-mobile
            v-if="menuToShow === 'home'"
            :applyHomeRenderDelay="showLoginSpinner"
            @applyLoginLoaderExitAnimation="emit('applyLoginLoaderExitAnimation')"/>
			<!-- Other Bottom menu entries -->
            <menu-page-with-entries v-if="menuToShow !== 'home' && menuToShow !== 'menu'" :menuData="menuToShowData"/>
            <!-- Full menu -->
            <navigation-mobile-menu-base
            v-if="menuToShow === 'menu'"
            :applyHomeRenderDelay="showLoginSpinner"
            @selectHome="menuToShow = 'home'"
            @showCardTypeMenu="showCardTypeMenuEntriesViewHandler"
            @applyLoginLoaderExitAnimation="emit('applyLoginLoaderExitAnimation')"/>
		</div>
        <!-- mobile-third-level-menu Teleport, NOTE z-index is 150, mixin style -> upBelowLayer2TeleportStyles -->
        <div id="mobile-third-level-menu-overlay-teleport"/>
		<!-- Bottom Menu -->
		<navigation-mobile-bottom-menu :selectedMenu="menuToShow" @clicked="bottomMenuClickHandler"/>
        <!-- Third Level Menu -->
        <transition name="side-entry-animation" mode="out-in">
            <div v-if="showCardTypeMenuEntriesView" class="card-type-menu-entries-view-wrapper">
                <third-level-menu :customRouteLink="customRouteLink" @backOrCloseClicked="removeThirdLevelMenu"/>
            </div>
        </transition>
    </div>
</template>

<script setup>
import HomeMobile from '@/views/home/HomeMobile'
import MenuPageWithEntries from '@/components/generic/navigation/mobile/MenuPageWithEntries'
import NavigationMobileMenuBase from '@/components/generic/navigation/mobile/MenuBase'
import NavigationMobileBottomMenu from '@/components/generic/navigation/mobile/BottomMenuBase'
import ThirdLevelMenu from '@/views/ThirdLevelMenu'
/* Vue */
import { ref } from 'vue'
import { useRoute } from 'vue-router'
import { getInitialEntry } from '@/assets/scripts/parsers/menu'
import { routeList } from '@/router/helpers/routes'
/* Store */
import { mapGetters } from '@/store/helpers/mappers'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
/* Emmitters */
const emit = defineEmits(['showMobileFlowsWrapperUpdate', 'toggleLoginSpinnerOverlay', 'applyLoginLoaderExitAnimation'])

/** props received
@animateMeLeft { Boolean } -prop to trigger translate-me-left animation
@showLoginSpinner {Boolean} - prop that tells if LoginSpinner is on
*/
const props = defineProps({
    animateMeLeft: Boolean,
    showLoginSpinner: Boolean
})

const { getPreventMobileFeatureBackState } = mapGetters()

const menuToShow = ref(getInitialEntry()?.link && getInitialEntry().link !== routeList.HOME_PATH && props.showLoginSpinner ? 'menu' : 'home')
const menuToShowData = ref()

const bottomMenuClickHandler = $event => {
    menuToShow.value = $event.id
    menuToShowData.value = $event
}

const showConfirmLogoutModal = ref(false)

/***********************************************************
*                                                          *
*             Card Type Menu Entries View Logic            *
*                                                          *
***********************************************************/
const customRouteLink = ref(null)
const showCardTypeMenuEntriesView = ref(false)
const showCardTypeMenuEntriesViewHandler = (menuEntry) => {
    customRouteLink.value = menuEntry.link
    showCardTypeMenuEntriesView.value = true
}

const removeThirdLevelMenu = () => {
    if (!currentRoute.fullPath.includes('mobileMenuhome')) return
    customRouteLink.value = null
    showCardTypeMenuEntriesView.value = false
}
/***********************************************************
*                                                          *
*                 MOBILE NATIVE BACK LOGIC                 *
*                                                          *
***********************************************************/
const currentRoute = useRoute()
const thirdLevelMenuOpenStatus = ref(false)

const onBackKeyDown = () => {
    if (!currentRoute.fullPath.includes('mobileMenuhome') || getPreventMobileFeatureBackState.value || thirdLevelMenuOpenStatus.value) return
    showConfirmLogoutModal.value = true
}

document.addEventListener('backbutton', onBackKeyDown, false)
</script>

<style lang="scss" scoped>
.authenticated-area-menu-controller {
    width: 100%;
    height: 100%;

    transition: transform 0.4s linear;

    &.translate-me-left {
        transform: translateX(-40%);
    }

    .display-content-wrapper {
        width: 100%;
        height: 100%;

		display: flex;
		flex-direction: column;

        &:after {
			content: "_";
			width: 100%;
			height: 56px; /* Bottom menu */
			display: inline-block;
			visibility: hidden;
			flex-shrink: 0;
			line-height: 0;
			font-size: 1px;
		}
    }

    .card-type-menu-entries-view-wrapper {
        width: 100%;
        height: 100%;

        position: absolute;
        top: 0;
        left: 0;

        background-color: var(--secondary-light-3);
        z-index: 10;

        transition: transform 0.4s linear;
        transform: translateX(0);

        &.side-entry-animation-enter-active,
        &.side-entry-animation-leave-active {
            transform:translateX(0);
        }

        &.side-entry-animation-enter-from,
        &.side-entry-animation-leave-to {
            transform:translateX(110%);
        }
    }
}
</style>
